// Vuex Client module mutations
import {
  FILL_LIST,
} from './mutations-types';

export default {
  [FILL_LIST](state, payload) {
    state.list = payload;
  },
};
